

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const EVENTGETBYID= createAsyncThunk(
  "EventGetById/EventGetById",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const EventGetByIdSlice = createSlice({
  name: "EventGetByIdSlice",
  initialState: {
    EventGetById: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfEventGetById: (state) => {
        state.EventGetById.loading = false
        state.EventGetById.error = false
        state.EventGetById.data = []
        state.EventGetById.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(EVENTGETBYID.fulfilled, (state, action) => {
      state.EventGetById = {
        ...state.EventGetById,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(EVENTGETBYID.pending, (state, action) => {
      state.EventGetById = {
        ...state.EventGetById,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(EVENTGETBYID.rejected, (state, action) => {
      state.EventGetById = {
        ...state.EventGetById,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const EventGetByIdAction = {
    EVENTGETBYID,
};

export { EventGetByIdAction };
export default EventGetByIdSlice.reducer;
export const {setInitialStateOfEventGetById} = EventGetByIdSlice.actions
